<template>
  <div
    class="effect-setting setting-popup"
    v-if='boxData.judgeBox'
    :style="{'top': boxData.fix.y+'px', 'left': boxData.fix.x+'px', 'z-index': boxData.Zindex}"
    @mousedown.stop.prevent
    @click="on$ElClicked()"
  >
    <div
      class="setting-popup__drag-area"
      @mousedown="moveStart($event, true)"
      @mousemove="moveArea($event)"
      @mouseup="saveMoveState($event)" :style="{'cursor': 'move'}"
    >
      基础
    </div>

    <div class="settting-popup__content">
      <ul class="items">
        <li class="item">
          <div class="item__title">透明度</div>
          <div class="item__main">
            <slider
              :runway-size="110"
              :number-unit="'%'"
              @updateValue="onTransparentUpdated"
              ref="transparentSlider"
            ></slider>
          </div>
        </li>
        <li
          class="item"
          v-if="sprite.type === 'Video' || sprite.sound"
        >
          <div class="item__title">音量</div>
          <div class="item__main">
            <slider
              :runway-size="110"
              :number-unit="''"
              @updateValue="onVolumeUpdated"
              ref="volumeSlider"
            ></slider>
          </div>
        </li>
        <li
          class="item"
          v-if="sprite.type === 'Lottie' || sprite.type === 'Gif' || sprite.type === 'Video'"
        >
          <div class="item__title">动效次数</div>
          <div class="item__main loop-counter" @click.stop="onInputNumberClicked()">
            <el-input-number
              size="mini"
              v-model="loop.count"
              :disabled="loop.isLoop"
              :min="1"
              :max="10"
              @change="onElementInputChange"
              @focus="onElementInputFocus"
              @blur="onElementInputBlur"
              ref="inputNumber"
            ></el-input-number>
          </div>
        </li>
        <li
          class="item"
          v-if="sprite.type === 'Lottie' || sprite.type === 'Gif' || sprite.type === 'Video'"
        >
          <div class="item__title">循环</div>
          <div class="item__main">
            <el-switch
              v-model="loop.isLoop"
              @change="infiniteLoopChange"
            >
            </el-switch>
          </div>
        </li>

        <!-- editable svg -->
        <li
          class="item"
          v-if="$isEditableShape(sprite.option.fileType)"
        >
          <div class="item__title">填充</div>
          <div class="item__main">
            <div
              class="color"
              @click="
                showColorPicker && showColorPicker({ whichPart: 'fill' });
                $analysis('base_setting_panel,click_fill_color,基础设置面板_填充');
              "
              :style="{backgroundColor: colorHex}"
            ></div>
          </div>
        </li>
        <li
          class="item"
          v-if="$isEditableSvg(sprite.option.fileType) && svgHasStroke"
        >
          <div class="item__title">线条</div>
          <div class="item__main" style="display: flex;">
            <div
              class="color"
              @click="
                showColorPicker && showColorPicker({ whichPart: 'stroke' });
                $analysis('base_setting_panel,click_stroke_color,基础设置面板_描边');
              "
              style="display: inline-block;"
              :style="{backgroundColor: strokeColorHex}"
            ></div>

          <div class="dropdown">
            <el-popover
              v-model="strokeWidth.isShowOptions"
              popper-class="stroke-width-dropdown"
              placement="bottom"
              width="80"
              trigger="click"
            >
              <div class="dropdown__select" slot="reference" @mousedown.stop>
                <span>
                  {{sprite.option.strokeWidth == null ? '请选择' : sprite.option.strokeWidth}}
                </span>
                <i class="icon-dropdown-arrow" :style="{transform: strokeWidth.isShowOptions ? `rotate(180deg)` : '', transitionDuration: '0.3s'}"></i>
              </div>
              <div class="dropdown__options">
                <div
                  class="dropdown__item"
                  v-for="(item, i) in getStrokeWidthOptions()"
                  :key="i"
                  :class="{active: item.active}"
                  @click="setStrokeWidth(item)"
                >
                  <span>{{item.value}}</span>
                  <span
                    :style="`display: inline-block;
                      width: 30px;
                      height: ${item.thickness}px;
                      background-color: #9692a9;`"
                ></span>
                </div>
              </div>
            </el-popover>
          </div>
          </div>
        </li>
        <li class="item">
          <div class="item__title" style="margin-top: 6px;">背景色</div>
          <div class="item__main" style="display: flex;">
            <div
              class="color"
              @click="
                showColorPicker && showColorPicker({ whichPart: 'bgColor' });
                $analysis('base_setting_panel,click_fill_bgcolor,基础设置面板_点击_背景色');
              "
              :style="{backgroundColor: bgColor}"
            ></div>
            <div class="cancel-color" @click="
              sprite.bgColor&&colorPickerInput ({hex: ''}, { type: 'bgColor' });
              $analysis('base_setting_panel,click_clear_fill_bgcolor,基础设置面板_点击_背景色');
            "></div>
          </div>
        </li>
        <li class="item" style="height: 70px;align-items: flex-start;">
          <div class="item__title" style="margin-top: 6px;">边框</div>
          <div class="item__main border-set">
            <div class="color"
              @click="
                showColorPicker && showColorPicker({ whichPart: 'borderColor' });
                $analysis('base_setting_panel,click_border_color,基础设置面板_边框_颜色');
              "
              :style="{backgroundColor: border.color}"
            ></div>
            <el-popover
            class="el-dropdown"
            popper-class="stroke-width-dropdown"
            placement="bottom"
            width="80"
            trigger="click">
              <span class="el-dropdown-link" slot="reference">
                <span :class="[border.style, 'border-style']" style="width: 34px;height: 6px;"></span>
                <i class="icon-dropdown-arrow"></i>
              </span>
              <div class="dropdown__options">
                <div
                  class="dropdown__item"
                  v-for="item in bStyele"
                  :key="item"
                  :class="{active: border.style === item}"
                  @click="
                    changeBorder(undefined, item, undefined);
                    $analysis('base_setting_panel,select_border_linetype,基础设置面板_选择_边框_线型');
                  "
                >
                  <span :class="[item, 'border-style']"></span>
                </div>
              </div>
            </el-popover>
            <el-popover
            class="el-dropdown"
            popper-class="stroke-width-dropdown"
            placement="bottom"
            width="80"
            style="margin-left: 0px;margin-top: 10px;"
            trigger="click">
              <span class="el-dropdown-link" slot="reference">
                <span>{{border.width}}</span>
                <i class="icon-dropdown-arrow"></i>
              </span>
              <div class="dropdown__options">
                <div
                  class="dropdown__item"
                  v-for="i in 11"
                  :key="i"
                  :class="{active: border.width === i-1}"
                  @click="
                    changeBorder(i-1, undefined, undefined);
                    $analysis('base_setting_panel,select_border_strokewidth,基础设置面板_选择_边框_线宽');
                  "
                >
                  <span>{{i-1}}</span>
                  <span class="border-width-item" :style="{height: `${i-1}px`}"></span>
                </div>
              </div>
            </el-popover>
          </div>
        </li>
        <li v-if="sprite.type !== 'Lottie'" class="item" style="align-items: flex-start;" :style="{height: oneRadius?'30px':'90px'}">
          <div class="item__title" style="margin-top: 6px;">圆角</div>
          <div class="item__main">
            <div class="radius-one">
              <input type="number"
              v-model="bRadius"
              :disabled="!oneRadius"
              @click.stop
              @keydown.stop="radiusKeyDown"
              @mousedown.stop
              @focus="inputFocus(4)"
              ref="borderRadius5"
              >
              <div class="select-one" :class="{'active': oneRadius}" @click="oneRadius=true">
                <span></span>
              </div>
              <div class="select-four" :class="{'active': !oneRadius}" @click="oneRadius=false;$analysis('base_setting_panel,click_senior_radius,基础设置面板_点击_高级圆角');">
                <i class="icon-border-radius"></i>
              </div>
            </div>
            <div class="radius-four" v-if="!oneRadius" @click.stop @keydown.stop="radiusKeyDown" @mousedown.stop>
              <div v-for="i in 4" :key="i">
                <input type="number" :ref="'borderRadius' + i" v-model="border.radius[i-1]" @focus="inputFocus(i-1)">
                <i :class="['border-radius-'+i]"></i>
              </div>
            </div>
          </div>
        </li>

      </ul>
    </div>

    <div class="setting-popup__close" @click="close"><i class="icon-popup-close"></i></div>
    <div class="setting-popup__mask" v-show="isShowMask" @click="closeNextPopup('color')"></div>
  </div>
</template>

<script>
import popup from '../../mixins/popup.vue'
import slider from '../../popups/content/slider.vue'

export default {
  mixins: [popup],
  components: {
    slider
  },
  data () {
    return {
      popupType: 'basicSetting',
      loop: {
        count: 5,
        isLoop: false,
        oldVal: 0
      },
      colorHex: '#5778fb',
      strokeColorHex: '#5778fb',
      strokeWidth: {
        min: 0,
        max: 10,
        isShowOptions: false
      },
      svgHasStroke: true,
      border: {
        width: 0,
        style: 'solid',
        color: '#888888',
        radius: [0, 0, 0, 0]
      },
      oneRadius: true,
      bRadius: 0,
      radiusIndex: -1,
      bStyele: ['solid', 'dashed', 'dotted', 'double'],
      inputDom: null,
      bgColor: ''
    }
  },
  watch: {
    'boxData.judgeBox': {
      handler (val) {
        if (val) {
          this.svgHasStroke = this.sprite && this.sprite.hasStroke && this.sprite.hasStroke();
          this.initData();
          this.$nextTick(() => {
            this.render();
          })
        } else {
          this.closeNextPopup('color');
        }
      }
    },
    'strokeWidth.isShowOptions' (val) {
      val && this.$analysis('base_setting_panel,click_strokewidth_list基础设置面板_线宽菜单');
    },
    'bRadius'(val, oldVal) {
      if(this.radiusIndex !== 4 || val == oldVal) return;
      this.bRadius = this.calcRadius(val)
      this.border.radius = [this.bRadius, this.bRadius, this.bRadius, this.bRadius];
      this.changeBorder()
    },
    'border.radius'(val, oldVal) {
      if(this.radiusIndex < 0 || this.radiusIndex > 3) return;
      this.border.radius[this.radiusIndex] = this.calcRadius(val[this.radiusIndex]);
      this.changeBorder();
    }
  },
  created () {
    this.$bus.on(`colorPickerInput.${this.popupType}`, this.colorPickerInput);
  },
  mounted () {
    const vm = this;
    this.$el.addEventListener('mousedown', () => {
      vm.strokeWidth.isShowOptions = false;
    });
    this.$bus.on('undoRedoHandle', (data) => {
      // 撤销和恢复的事件
      if (data.type === 'bgColor' || data.type === 'changeBorder') this.initData();
    })
  },
  methods: {
    initData() {
      if(!this.boxData.judgeBox) return;
      let border = this.sprite.border;
      this.radiusIndex = -1;
      this.bgColor = this.sprite.bgColor || '#fff';
      this.oneRadius = true;
      if(!border) {
        this.border = {
          width: 0,
          style: 'solid',
          color: '#888888',
          radius: [0, 0, 0, 0]
        }
        this.bRadius = 0;
      } else {
        Object.assign(this.border, border);
        delete this.border.dom;
        this.border.radius = [].concat(border.radius);
        this.bRadius = this.border.radius[0];
        this.border.radius.forEach((item) => {
          if(item !== this.bRadius) this.oneRadius = false;
        })
      }
    },
    render () {
      const vm = this;
      const sprite = vm.sprite;

      vm.$refs.transparentSlider
        && vm.$refs.transparentSlider.updateValFromOutside(vm.sprite.getTransparent());

      if (vm.$refs.volumeSlider && vm.sprite) {
        vm.sprite.sound && vm.$refs.volumeSlider.updateValFromOutside(vm.sprite.sound.volume);
        vm.sprite.type === 'Video'
          && vm.$refs.volumeSlider.updateValFromOutside(vm.sprite.video.volume);
      }

      if (sprite.type === 'Lottie' || sprite.type === 'Gif' || sprite.type === 'Video') {
        this.loop.isLoop = this.sprite.getLoop().isLoop;
        this.loop.count = this.sprite.getLoop().numberOfLoops;
      }

      this.updateItemColor();

      this.strokeWidth.isShowOptions = false;
    },
    onTransparentUpdated (val, undo) {
      this.sprite.setTransparent({
        percent: val,
        undo
      });
      if (undo) {
        this.$analysis('base_setting_panel,drag_opacity,基础设置面板_透明度');
      }
    },
    onVolumeUpdated (val, undo) {
      if (!undo) {
        return;
      }
      if(this.sprite && this.sprite.sound){
        this.sprite.setSound({
          volume  : val,
        })
      }
      if (this.sprite && this.sprite.type === 'Video')
      this.sprite.setVolume(val, undo);

      this.$analysis('base_setting_panel,drag_volume,基础设置面板_音量');
    },

    onElementInputChange (val, oldVal, ...args) {
      this.$analysis('base_setting_panel,click_updown,基础设置面板_动效次数增减');
      if (('' + val).trim === '' || val == null) {
        this.loop.count = this.sprite.numberOfLoops;
      }
      if (val > 10 || val < 1 || val == null) {
        val = oldVal;
        return;
      }

      if (this.sprite.type === 'Video') {
        this.sprite.setRepeatTimes(val, true);
        return;
      }
      this.sprite.setLoop(val, true);
    },
    onElementInputFocus (ev) {
      this.togglePreventDefault(false);
      if (ev.target.value) {
        this.loop.oldVal = ev.target.value;
      }
      this.inputDom = this.$refs.inputNumber;
      this.$analysis('base_setting_panel,click_actionTimes,基础设置面板_动效次数');
    },
    onElementInputBlur (ev) {
      this.togglePreventDefault(true);
      let o = ev.target.value;
      setTimeout(() => {
        if (ev.target.value.trim() === '') {
          ev.target.value = /* o || this.loop.oldVal ||  */this.sprite.getLoop().numberOfLoops;
        }
      }, 30)
    },
    togglePreventDefault(val) {
      // 是否启用快捷键
      this.$store.commit('toggle_isPreventDefault', val);
    },

    infiniteLoopChange (bool) {
      this.sprite.setLoop(bool, true);
      this.$analysis(
        bool
          ? 'base_setting_panel,click_action_recyle_open,基础设置面板_动效循环_开'
          : 'base_setting_panel,click_action_recyle_close,基础设置面板_动效循环_关'
      );
    },

    showColorPicker ({ whichPart } = {}) {
      this.$bus.emit('FeaturesPop_vue', {
        name: 'color',
        // 使用了mixins popup.vue 下两字段就非必传
				// posx : rect.left,
				// posy : rect.top,
        type: 1,
        // color: this.color,
        source: this,
        whichPart,
        color: this.sprite.option[whichPart]
      });
      this.toggleMask(true);
    },
    updateItemColor () {
      let sprite = this.sprite || {};
      let color;
      let strokeColor;
      if (sprite.type === 'Svg') {
        color = sprite.option.fill || sprite.fill;
        strokeColor = sprite.option.stroke || sprite.stroke;
      }
      if (sprite.type === 'Shape') {
        color = sprite.option.style.color
      }
      if (sprite.type === 'Text') {
        color = sprite.font.color
      }
      this.colorHex = color || '#5778fb';
      this.strokeColorHex = strokeColor || '#5778fb';
    },
    colorPickerInput (obj, { type }) {
      if(type === 'borderColor') {
        this.changeBorder(undefined, undefined, obj.hex)
        return;
      } else if(type === 'bgColor') {
        eve("undo_redo", null, { type: 'bgColor', data: {
          spriteId: this.sprite.id,
          scenesId: this.sprite.scenesId,
          data: obj.hex,
          reData: this.sprite.bgColor
        }})
        this.bgColor = obj.hex || '#fff';
        this.sprite.setBgColor(obj.hex);
        return;
      }
      const vm = this;
      vm.changeColor(obj, { type });
      this.color = obj.hex;
      vm.$bus.emit('changeSelectScenes_vue', vm.SelectScenes_Msg);
    },
    changeColor (obj, {
      type = 'fill'
    } = {}) {
      let {hex} = obj;
      this.TOOL.updateSprite(this.sprite.id, {
        [type]: hex
      }, null, true)
        .then(() => {
          this.updateItemColor();
        })
    },

    getStrokeWidthOptions () {
      let sprite = this.sprite;
      let arr = [];
      for (let v = this.strokeWidth.min; v <= this.strokeWidth.max; v++) {
        arr.push({
          value: v,
          // thickness: v * Math.min(sprite.width / sprite.initData.width, sprite.height / sprite.initData.height)
          thickness: v,
          active: v === sprite.option.strokeWidth
        })
      };
      return arr;
    },

    toggleStrokeWidthOptions () {
      this.strokeWidth.isShowOptions = !this.strokeWidth.isShowOptions;
    },

    setStrokeWidth (item) {
      this.TOOL.updateSprite(this.sprite.id, {
        strokeWidth: item.value
      }, null, true)
        .then(() => {
          this.$bus.emit('strokeWidthUpdated_vue', this.sprite.option.strokeWidth);
          if (this.$isEditableShape(this.sprite.option.fileType)) {
            this.$analysis({category:'material_setting_panel', action:'click_outline_width', label:'素材设置_边框粗细'});
          }
          if (this.$isEditableShape(this.sprite.option.fileType)) {
            this.$analysis({category:'material_setting_panel', action:'click_line_width', label:'素材设置_线条粗细'});
          }
        })
    },

    onInputNumberClicked () {
      this.$refs.inputNumber &&
        this.$refs.inputNumber.$el.querySelector('input').focus();
    },
    on$ElClicked () {
      if(this.inputDom) {
        if(this.inputDom.$el) {
          this.inputDom.$el.querySelector('input').blur();
        }else {
          this.inputDom.blur();
        }
        this.inputDom = null;
      }
    },
    changeBorder(width, style, color) {
      let s = this.sprite;
      let undoData = {
        spriteId: s.id,
        scenesId: s.scenesId,
        reData: s.border ? $.extend({}, s.border) : null
      }
      if(undoData.reData && undoData.reData.dom) delete undoData.reData.dom;
      typeof width === 'number' && (this.border.width = width)
      style && (this.border.style = style)
      color && (this.border.color = color)
      let border = Object.assign({},this.border);
      border.radius = [].concat(this.border.radius);
      undoData.data = $.extend({}, border);
      this.sprite.setBorder(border)
      eve("undo_redo", null, { type: 'changeBorder', data: undoData})
    },
    calcRadius(n) {
      n = Math.round(n)
      if(n > 100) {
        n = 100;
      } else if(n < 0) {
        n = 0
      }
      return n;
    },
    inputFocus(i) {
      this.radiusIndex = i;
      this.inputDom = this.$refs['borderRadius'+(i+1)]
      if(this.inputDom && this.inputDom.length) this.inputDom = this.inputDom[0]
    },
    radiusKeyDown(e) {
      if(e.keyCode === 38 || e.keyCode === 40) {
        this.$analysis({
          category: 'base_setting_panel',
          action: 'radius_key_updown',
          label: '基础设置面板_上下调整_圆角'
        })
      } else {
        this.$analysis({
          category: 'base_setting_panel',
          action: 'radius_keyenter',
          label: '基础设置面板_键盘输入_圆角'
        })
      }
    }
  }
}
</script>

<style lang="scss" scoped>
.setting-popup {
  position: fixed;
  top: 0;
  left: 0;
  width: 258px;
  min-height: 180px;
  z-index: 35;
  box-shadow: #d8dee9 0px 0px 5px 0px;
  border-radius: 8px;
  background: #fff;
  overflow: hidden;
  font-size: 14px;
  box-shadow: 0 0 0 1px #d8dee9;
  color: #474261;

  &__drag-area {
    line-height: 28px;
    background: #d8dee9;
    text-align: left;
    text-indent: 14px;
    cursor: move;
  }

  &__close {
    position: absolute;
    top: 7px;
    right: 12px;
    height: 14px;
    line-height: 14px;
    width: 14px;
    cursor: pointer;
  }

  &__content {
    padding: 14px 0;
  }

  &__mask {
    position: absolute;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    background-color: rgba(#ffffff, 0.7);
  }
}

.items {
  padding-top: 25px;
}

.item {
  display: flex;
  align-items: center;
  justify-content: flex-start;
  padding-left: 14px;
  margin-bottom: 25px;
  height: 19.2px;

  &:last-child {
    margin-bottom: 36px;
  }

  &__title {
    flex-shrink: 0;
    width: 56px;
    margin-right: 10px;
    text-align: left;
  }
}

.color {
  width: 75px;
  height: 30px;
  border-radius: 4px;
  background-color: #5779fa;
  cursor: pointer;
  border: 1px solid #D9DDE9;
}

.dropdown {
  position: relative;
  &__select {
    display: flex;
    justify-content: space-between;
    align-items: center;
    width: 80px;
    height: 30px;
    line-height: 30px;
    border: solid 1px #D9DDE9;
    margin-left: 15px;
    cursor: pointer;
    text-align: left;
    padding-left: 12px;
    padding-right: 12px;
  }
  &__options {
    // position: absolute;
    z-index: 1;
    top: 120%;
    left: 15px;
    width: 80px;
    border: solid 1px #D9DDE9;
  }
  &__item {
    display: flex;
    justify-content: center;
    align-items: center;
    height: 24px;
    line-height: 24px;
    background-color: #fff;
    cursor: pointer;

    & > span:nth-child(1) {
      width: 25px;
      text-align: left;
      color: #9692a9;
    }
    &:hover, &.active {
      background-color: #D9DDE9;
    }
  }
}
.border-set {
  display: flex;
  flex-wrap: wrap;
}
.el-dropdown {
  width: 80px;
  height: 30px;
  line-height: 30px;
  border: solid 1px #D9DDE9;
  margin-left: 15px;
  cursor: pointer;
  text-align: left;
  padding-left: 12px;
  padding-right: 12px;
}
.el-dropdown-link {
  display: flex;
  justify-content: space-between;
  align-items: center;
  height: 30px;
}
.border-style {
  display: inline-block;
  width: 40px;
  height: 13px;
  margin-bottom: 2px;
  border-bottom: 5px solid #9692a9;
}
.border-style.dashed {
  border-bottom-style: dashed;
}
.border-style.dotted {
  border-bottom-style: dotted;
}
.border-style.double {
  border-bottom-style: double;
}
.border-width {
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 0 10px;
  width: 80px;
  height: 25px;
  background-color: #ffffff;
}
.border-width-item {
  width: 30px;
  background-color: #9692a9;
}
.radius-one {
  display: flex;

  input {
    width: 80px;
    height: 30px;
    border: 1px solid #D9DDE9;
    text-align: center;
  }
  input:disabled {
    color: #D9DDE9;
    background-color: #ffffff;
  }
  .select-one, .select-four {
    width: 30px;
    height: 30px;
    border: 1px solid #D9DDE9;
    border-radius: 4px;
    background-color: #fff;
    margin-left: 5px;

    &.active {
      border-color: #5778FD;
      background-color: #F6F7FC;
      span {
        border-color: #5778FD;
      }
    }

    span {
      display: block;
      border: 1px solid #474260;
      margin: 5px;
      border-radius: 4px;
      width: 18px;
      height: 18px;
      background-color: #fff;
    }
  }
}
.select-four i {
  width: 100%;
  height: 100%;
  background-size: 17px;
  background-position: center;
}
.radius-four {
  display: flex;
  flex-wrap: wrap;

  >div {
    position: relative;
  }

  input {
    width: 80px;
    height: 30px;
    text-align: center;
    border: 1px solid #D9DDE9;
    margin: 8px 5px 0 0;
    border-radius: 4px;
    background-color: #F6F7FC;
  }
  
  input:focus {
    border-color: #5778FD;
  }

  i {
    position: absolute;
    top: 15px;
    left: 8px;
    display: block;
    width: 15px;
    height: 15px;
    border: 1px solid #5778FD;
    border-radius: 5px;
  }
  i.border-radius-1 {
    clip-path: polygon(70% 0, 0 70%, 0 0)
  }
  i.border-radius-2 {
    left: 58px;
    clip-path: polygon(30% 0, 100% 0, 100% 70%)
  }
  i.border-radius-3 {
    clip-path: polygon(0 30%, 70% 100%, 0 100%)
  }
  i.border-radius-4 {
    left: 58px;
    clip-path: polygon(100% 30%, 100% 100%, 30% 100%)
  }
}
.cancel-color {
  width: 30px;
  height: 30px;
  margin-left: 15px;
  border: 1px solid #D9DDE9;
  border-radius: 3px;
  cursor: pointer;

  &:hover {
    background-color: #F6F7FC;
  }

  &::before {
    content: '';
    position: relative;
    top: 13px;
    left: 4px;
    display: block;
    transform: rotate(-45deg);
    width: 20px;
    height: 1px;
    background-color: #FF292B;
  }
}
</style>



// WEBPACK FOOTER //
// src/components/popupsNew/basicSetting/basicSetting.vue